import ChangePasswordMain from '@/components/ChangePassword'
const ChangePassword = () => {
    const element = (<><ChangePasswordMain /></>);
    return element
}
export default ChangePassword